<template>
  <div class="add_main_screen" v-if="deviceType !== 'pc'">
    <div class="txt">{{ $t('m.link_add_mainpage') }}</div>
    <div class="btn" @click="goAddNotePage()">{{ $t('m.click_me_to_add') }}</div>
  </div>
</template>
<script>
export default{
  name:'addScreen',
  data(){
    return{
      deviceType:'',
    }
  },
  created() {

    this.getDeviceType();
  },
  methods:{
    //获取设备类型
    getDeviceType() {
      let ua = navigator.userAgent;
      if (ua.match(/(iPhone|iPod|iPad|ios);?/i)) {
        document.title = this.$t('m.charge');
        this.deviceType = 'ios';
        return 'ios';
      }
      if (ua.match(/android/i)) {
        document.title = this.$t('m.charge');
        this.deviceType = 'android';
        return 'android';
      }
      this.deviceType = 'pc';
      return 'pc';
    },
    //跳转到添加到主屏幕说明页
    goAddNotePage() {
      let host = window.location.host
      let url = this.global_huanjing.urlh5
      if(host === 'pay.buzzcast.buzz') {
        url = 'https://static.buzzcast.buzz'
      }
      if (this.deviceType == 'ios') {
        window.location.href = url + "/add_mainpage_note/ios.html"
      } else if (this.deviceType == 'android') {
        window.location.href = url + "/add_mainpage_note/android.html"
      }
    },
  }
}
</script>
<style scoped>

.add_main_screen {
  display: flex;
  align-items: center;
  min-height: .54rem;
  background-color: #D0E9FF;
  font-size: .24rem;
  padding: .15rem;
}

.add_main_screen .txt {
  flex: 1;
  padding: 0 .15rem;
}

.add_main_screen .btn {
  padding: .08rem .2rem;
  /* line-height: 1.3; */
  border-radius: 5rem;
  background-color: #008AFF;
  color: #fff;
  max-width: 2rem;
}

</style>



// WEBPACK FOOTER //
// src/components/addscreen.vue